import { useApp } from '@/contexts/AppContext';

export default function ToastContainer() {
  const { toasts, removeToast } = useApp();

  return (
    <div className="fixed top-4 right-4 z-[60] space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg border text-sm font-medium animate-[slideIn_0.3s_ease-out] ${
            toast.type === 'success'
              ? 'bg-green-50 border-green-200 text-green-800'
              : toast.type === 'error'
              ? 'bg-red-50 border-red-200 text-red-800'
              : toast.type === 'warning'
              ? 'bg-amber-50 border-amber-200 text-amber-800'
              : 'bg-navy-50 border-navy-200 text-navy-800'
          }`}
        >
          <i
            className={`${
              toast.type === 'success'
                ? 'ri-checkbox-circle-line text-green-600'
                : toast.type === 'error'
                ? 'ri-error-warning-line text-red-600'
                : toast.type === 'warning'
                ? 'ri-alert-line text-amber-600'
                : 'ri-information-line text-navy-600'
            } text-lg`}
          />
          <span>{toast.message}</span>
          <button
            onClick={() => removeToast(toast.id)}
            className="ml-2 text-navy-400 hover:text-navy-600"
          >
            <i className="ri-close-line" />
          </button>
        </div>
      ))}
    </div>
  );
}